import React from 'react';
import moment from 'moment-timezone';
import { Map, Marker, InfoWindow, Polyline } from 'components/maps';

export const ShipmentWaypointMap = ({
  waypoints,
  center,
  height,
  markers,
  visibleMarker,
  onMouseOver,
  onMouseOut,
}) => {
  const path =
    waypoints.length > 30
      ? waypoints.filter((_item, index) => index % 3 === 0)
      : waypoints;

  const formatted = path.map((item, idx) => ({
    timestamp: item.timestamp,
    lat: item.position.lat,
    lng: item.position.lng,
    mapKey: item.timestamp + idx,
  }));

  return (
    <Map height={height} defaultZoom={10} defaultCenter={center}>
      {formatted.map((stop) => (
        <React.Fragment key={stop.mapKey}>
          <Marker
            icon={{
              url: '/img/waypoint.png',
              scaledSize: { width: 20, height: 20 },
            }}
            onMouseOver={() => onMouseOver?.(stop.timestamp)}
            onMouseOut={() => onMouseOut?.()}
            position={{ lat: stop.lat, lng: stop.lng }}
          />
          {visibleMarker === stop.timestamp && (
            <InfoWindow position={{ lat: stop.lat, lng: stop.lng }}>
              <div>{moment(stop.timestamp).calendar()}</div>
            </InfoWindow>
          )}
        </React.Fragment>
      ))}
      <Polyline
        path={formatted.map((p) => ({ lat: p.lat, lng: p.lng }))}
        options={{
          geodesic: true,
          strokeColor: '#25AA82',
          strokeWeight: 2,
        }}
      />
      {markers}
    </Map>
  );
};

export { ShipmentWaypointMap as Map };
